export const CartAnalyticsEvent = {
  AddressChanged: 'addressChanged',
  CartEmptied: 'cartEmptied',
  CartItemAdd: 'cartItemAdd',
  CartItemChangeCount: 'cartItemChangeCount',
  CartItemClickedInCheckout: 'cartItemClickedInCheckout',
  CartItemRemoval: 'cartItemRemoval',
  CartPageLoad: 'cartPageLoad',
  CartTopperItemClickedInCheckout: 'cartTopperItemClickedInCheckout',
  Checkout: 'checkout',
  CheckoutPageLoad: 'checkoutPageLoad',
  DrawerContinueShopping: 'drawerContinueShopping',
  DrawerClosed: 'drawerClosed',
  DrawerProceedToCheckout: 'drawerProceedToCheckout',
  MenuLoad: 'menuLoad',
  ProductView: 'productView',
  ReportCartDisabled: 'reportCartDisabled',
  ReportCheckoutDisabled: 'reportCheckoutDisabled',
} as const;

export type CartAnalyticsEventName =
  (typeof CartAnalyticsEvent)[keyof typeof CartAnalyticsEvent];
